<template>
  <div class="col-lg col-md-12">
    <div
      class="text-center font-weight-bold text-white mb-3 mb-lg-0 rounded-3"
      :class="`bg-${type}`"
    >
      <p
        class="m-0"
        :class="`fs-${fs}`"
      >
        {{ text }}
      </p>
      <p
        class="m-0"
        :class="`fa-${fs}x`"
      >
        {{ number | moneyFormatter }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "StatBadge",
  props: {
    type: {
      type: String,
      required: true
    },
    fs: {
      type: Number,
      default: 1
    },
    text: {
      type: String,
      required: true
    },
    number: {
      type: Number,
      required: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/StatBadge.vue